import { FC } from "react";
import { Link, useNavigate } from "react-router-dom";
import { SinglePostDropDownActions } from "./SinglePostDropdownAction";
import { PostData } from "../../types/singlePostsProps";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import BaseUserAvatar from "@/components/BaseUserAvatar";
import { Avatar, Box, Card, Flex, Grid, Text } from "@radix-ui/themes";

export const SinglePostInfo: FC<{
  authorUsername: string;
  authorLogo: string;
  authorSlug: string;
  type: string;
  whenWasPosted: any;
  wasEdited: boolean;
  setIsDeleted: React.Dispatch<React.SetStateAction<boolean>>;
  setIsEditPost: React.Dispatch<React.SetStateAction<boolean>>;
  isAuthorized: boolean;
  postId: any;
  currUserSlug: string;

  isInModal: boolean;
  postData: PostData;
}> = ({
  authorUsername,
  authorLogo,
  authorSlug,
  type,
  whenWasPosted,
  wasEdited,
  setIsDeleted,
  setIsEditPost,
  isAuthorized,
  postId,
  currUserSlug,
  isInModal,
}) => {
  const textMapping: {
    [key: string]: string;
  } = {
    userPost: "",
    sharedPost: "shared a post",
    sharedChallenge: "shared a challenge",
    sharedTeam: "shared a team",
    sharedNews: "shared a news",
  };
  const currentUser = useCurrentUserProfile((s) => s.user);
  const navigate = useNavigate();

  try {
    return (
      <Grid gap="3" columns="12">
        <Box
          gridColumnStart={{ initial: "1", md: "1" }}
          gridColumnEnd={{ initial: "3", md: "2" }}
        >
          {/* Avatar */}
          <Avatar
            src={authorLogo}
            fallback={authorUsername.slice(0, 1)}
            radius="full"
            size="3"
          />
        </Box>
        <Box
          gridColumnStart={{ initial: "3", md: "2" }}
          gridColumnEnd={{ initial: "11", md: "12" }}
          asChild
          onClick={() => navigate(`/profile/${authorSlug}`)}
        >
          <Flex justify="center" direction="column">
            <Text size="3">{authorUsername}</Text> {textMapping[type]}
            <Text size="1" color="gray">
              {whenWasPosted?.howLongAgo}
              {wasEdited && <Text>&#9679; Edited</Text>}
            </Text>
          </Flex>
        </Box>
        <Box
          gridColumnStart={{ initial: "11", md: "12" }}
          gridColumnEnd={{ initial: "13", md: "13" }}
        >
          {!isInModal && (
            <SinglePostDropDownActions
              setIsEditPost={setIsEditPost}
              postId={postId}
              belongsToCurrentUser={authorSlug === currUserSlug}
              isAuthorized={isAuthorized}
              currUserSlug={currUserSlug}
              setIsDeleted={setIsDeleted}
            />
          )}
        </Box>
      </Grid>
    );
  } catch {
    <></>;
  }
};
